import bsn from 'libraries/bootstrap-native.js';
import cookies from 'cookies.js';
import events from 'events.js';
import http from 'http.js';
import ko from 'knockout';
import {page} from 'page.js';

import 'ko/elements/call_now_button.js';

(async function () {
    await events.ready();

    const replyButtons = Array.from(
        document.getElementsByClassName('open-reply'),
    );
    for (const button of replyButtons) {
        events.listen(button, 'click', function () {
            event.preventDefault();
            const pk = button.dataset.replyPk;
            const replyPanel = document.getElementById(`reply-${pk}`);

            replyPanel.style.display =
                replyPanel.style.display === 'none' ? 'block' : 'none';
        });
    }

    const toggleTagsButtons = document.querySelectorAll('button.toggle-tags');
    const extraTopics = Array.from(
        document.getElementsByClassName('topic more'),
    );
    for (const button of toggleTagsButtons) {
        events.listen(button, 'click', function () {
            button.innerText =
                button.innerText === 'See More' ? 'Show Less' : 'See More';
            for (const topic of extraTopics) {
                topic.classList.toggle('hidden');
            }
        });
    }

    const seeMorePros = document.querySelector('li.see-more-professionals');
    if (seeMorePros) {
        const extraPros = document.querySelectorAll('li.more');
        events.listen(seeMorePros, 'click', function () {
            seeMorePros.innerText =
                seeMorePros.innerText === 'See More'
                    ? 'Show Less'
                    : 'See More';
            for (const pro of extraPros) {
                pro.classList.toggle('hidden');
            }
        });
    }

    const questionFlyout = document.getElementsByClassName(
        'question-flyout',
    )[0];
    if (questionFlyout) {
        const basis = (function () {
            const docEl = document.documentElement;
            const origScrollTop = docEl.scrollTop++;
            const el =
                docEl.scrollTop === origScrollTop + 1 ? docEl : document.body;
            docEl.scrollTop = origScrollTop;
            return el;
        })();
        const threshold =
            (document.body.scrollHeight - window.innerHeight) / 2;
        let toggleStabilizer = false;
        let scrollFlag = false;
        events.listen(window, 'scroll', function () {
            scrollFlag = true;
        });
        setInterval(function () {
            if (scrollFlag) {
                scrollFlag = false;
                if (toggleStabilizer && basis.scrollTop < threshold) {
                    questionFlyout.classList.toggle('hidden');
                    toggleStabilizer = false;
                } else if (!toggleStabilizer && basis.scrollTop > threshold) {
                    questionFlyout.classList.toggle('hidden');
                    toggleStabilizer = true;
                }
            }
        }, 30);

        const closeCircle = document.getElementsByClassName('close-circle')[0];
        if (closeCircle) {
            events.listen(closeCircle, 'click', function () {
                questionFlyout.classList.toggle('hide');
            });
        }
    }

    const replyLogins = Array.from(
        document.getElementsByClassName('reply-login'),
    );
    for (const replyLogin of replyLogins) {
        events.listen(replyLogin, 'click', function () {
            new bsn.Modal(document.getElementById('login')).show();
        });
    }

    const replySignups = Array.from(
        document.getElementsByClassName('reply-signup'),
    );
    for (const replySignup of replySignups) {
        events.listen(replySignup, 'click', function () {
            new bsn.Modal(document.getElementById('signup')).show();
        });
    }

    // Feedback Scripts
    const popoverDelay = 7000;

    const agreeButtons = Array.from(
        document.getElementsByClassName('js-reply-button-agree'),
    );
    for (const agreeButton of agreeButtons) {
        const template = `<div><div class="popover-content">
            Thanks for the feedback, keep it coming!</div></div>`;
        const popover = new bsn.Popover(agreeButton, {
            trigger: 'click',
            placement: 'top',
            delay: popoverDelay,
            template,
        });
        let hideRef;
        events.listen(agreeButton, 'shown.bs.popover', function () {
            hideRef = setTimeout(function () {
                popover.hide();
            }, popoverDelay);
        });
        events.listen(agreeButton, 'hidden.bs.popover', function () {
            clearTimeout(hideRef);
        });

        events.listen(agreeButton, 'click', function (evt) {
            evt.preventDefault();
            const replyID = agreeButton.dataset.replyId;
            agreeButton.classList.remove('btn-success');
            agreeButton.classList.add('btn-default');

            const url = `/questions/reply/${replyID}/agree/`;
            http.post({url}).then(function (data) {
                updateCount(`total-agrees-${replyID}`);
                postFeedbackUIChange(agreeButton, 'Agreed');
            });
        });
    }

    const thanksButtons = Array.from(
        document.getElementsByClassName('js-reply-button-thanks'),
    );
    for (const thanksButton of thanksButtons) {
        const content = thanksButton.dataset.content;
        const template = `<div><div class="popover-content">
            ${content}</div></div>`;
        const popover = new bsn.Popover(thanksButton, {
            trigger: 'click',
            placement: 'top',
            delay: popoverDelay,
            template,
        });
        let hideRef;
        events.listen(thanksButton, 'shown.bs.popover', function () {
            hideRef = setTimeout(function () {
                popover.hide();
            }, popoverDelay);
        });
        events.listen(thanksButton, 'hidden.bs.popover', function () {
            clearTimeout(hideRef);
        });

        events.listen(thanksButton, 'click', function (evt) {
            evt.preventDefault();
            const replyID = thanksButton.dataset.replyId;
            thanksButton.classList.remove('btn-success');
            thanksButton.classList.add('btn-default');

            const url = `/questions/reply/${replyID}/thanks/`;
            http.post({url}).then(function (data) {
                updateCount(`total-thanks-${replyID}`);
                postFeedbackUIChange(thanksButton, 'Thanked');
                setFeedbackCookie(replyID);
            });
        });
    }

    const reportLinks = Array.from(
        document.getElementsByClassName('report-button'),
    );

    for (const link of reportLinks) {
        const pk = link.dataset.replyPk;
        const reportPanel = document.getElementById(`report-${pk}`);

        events.listen(link, 'click', function () {
            event.preventDefault();
            reportPanel.classList.toggle('hidden');
        });
        const form = reportPanel.getElementsByTagName('form')[0];

        if (form) {
            const reasonField = form[`${form.id}-reason`];
            events.listen(link, 'click', function () {
                event.preventDefault();
                reasonField.focus();
            });

            events.listen(form, 'submit', async function () {
                event.preventDefault();

                const replyField = form[`${form.id}-reply`];
                const token = form.csrfmiddlewaretoken;
                const data = {
                    reply: replyField.value,
                    reason: reasonField.value,
                    csrfmiddlewaretoken: token.value,
                };
                const url = form.dataset.url;

                http.post({url, data}).then(function () {
                    form.reset();
                    const replyAuthor = form.dataset.replyAuthor;
                    const message = `This reply by ${replyAuthor} has been\
                        reported to a HealthShare administrator for review.`;

                    page.messageGap = 0;
                    page.alert(page.alertTypes.INFO, message, 7000);
                    reportPanel.classList.toggle('hidden');
                });
            });
        }
    }
})();

function postFeedbackUIChange(feedbackButton, newText) {
    feedbackButton.disabled = 'disabled';
    feedbackButton.getElementsByClassName('js-action')[0].innerText = newText;
}

function setFeedbackCookie(threadreplyID) {
    const oldCookie = cookies.get('threadreply_thanks');
    let value;
    if (oldCookie === null) {
        value = threadreplyID;
    } else {
        value = `${oldCookie}_${threadreplyID}`;
    }
    cookies.set('threadreply_thanks', value);
}

function updateCount(countID) {
    const totalAgreeCount = document.getElementById(countID);
    const totalAgreeBox = totalAgreeCount.parentNode;
    const answerStatsBox = totalAgreeBox.parentNode;
    totalAgreeBox.classList.remove('hidden');
    answerStatsBox.classList.remove('hidden');
    totalAgreeCount.innerText = parseInt(totalAgreeCount.innerText) + 1;
}

const elems = document.querySelectorAll('[data-enquiry-section]');
for (const elem of elems) {
    ko.applyBindings(null, elem);
}
